export const feedbackTranslation = {
  form_error: 'An error occurred while submitting the form.',
  load_error: 'An error occurred while loading {{resource}}',
  user_registered: 'User successfully registered!',
  user_logged: 'Log In successful!',
  company_created: 'Company successfully created!',
  job_created: 'Job successfully created!',
  candidate_created: 'Candidate successfully created!',
  candidate_edited: 'Candidate successfully edited!',
};